<template><ArticlePage page="disclaimer" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/disclaimer.js';
export default { name: 'Disclaimer', components: { ArticlePage }, data: () => ({ content }) };
</script>
